"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MissingPermissionTypesForNetwork = exports.MissingPermissionTypes = exports.REQUIRED_APP_PERMISSIONS = exports.Networks = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var Networks = {
  ADWORDS: 'ADWORDS',
  FACEBOOK: 'FACEBOOK',
  LINKEDIN: 'LINKEDIN'
}; // Unfortunately, QA app doesn't have business_management scope

exports.Networks = Networks;
var isQA = window.location.hostname.indexOf('hubspotqa') > -1;
var FacebookScopes = (0, _keyMirror.default)((0, _extends2.default)({
  ads_management: null,
  leads_retrieval: null,
  manage_pages: null,
  pages_show_list: null
}, isQA ? {} : {
  business_management: null
}));
var REQUIRED_APP_PERMISSIONS = (0, _defineProperty2.default)({}, Networks.FACEBOOK, Object.keys(FacebookScopes));
exports.REQUIRED_APP_PERMISSIONS = REQUIRED_APP_PERMISSIONS;
var MissingPermissionTypes = (0, _keyMirror.default)({
  LEAD_SYNCING: null
});
exports.MissingPermissionTypes = MissingPermissionTypes;
var MissingPermissionTypesForNetwork = (0, _defineProperty2.default)({}, MissingPermissionTypes.LEAD_SYNCING, (0, _defineProperty2.default)({}, Networks.FACEBOOK, [FacebookScopes.leads_retrieval, FacebookScopes.manage_pages, FacebookScopes.pages_show_list].concat((0, _toConsumableArray2.default)(isQA ? [] : [FacebookScopes.business_management]))));
exports.MissingPermissionTypesForNetwork = MissingPermissionTypesForNetwork;